import { render, staticRenderFns } from "./UserVideo.vue?vue&type=template&id=6c6dd24f&scoped=true&"
import script from "./UserVideo.vue?vue&type=script&lang=js&"
export * from "./UserVideo.vue?vue&type=script&lang=js&"
import style0 from "./UserVideo.vue?vue&type=style&index=0&id=6c6dd24f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6dd24f",
  null
  
)

export default component.exports